export function fillPlaceholders(url: string, properties: Record<string, any>): string {
    const urlPlaceholders = getPlaceholders(url);
    if (!urlPlaceholders?.length) return url;

    return urlPlaceholders.reduce((finalUrl, placeholder) =>
        finalUrl.replace(`:${placeholder}`, placeholder in properties ? properties[placeholder] : ''), url);
}

export function getPlaceholders(url: string): string[] {
    const placeholderRegex = /(:[A-z]+)/g;
    return url.match(placeholderRegex)?.map(elem => elem.replace(':', '')) || [];
}
